﻿<script>
	import { siteSettings } from "../config";
    import { registerFormStart } from "../tealium";

    import { pageNumber, currentPage } from '../stores/pageStore';
	import PageSection from "../components/PageSection.svelte";
	import Form from "../components/Form.svelte";
	import NavigationButtons from "../components/NavigationButtons.svelte";

	let buttons;

	const handleSubmit = async (e) => {
		//e.preventDefault();
		buttons.blockNext();

		registerFormStart();

		buttons.next();
		buttons.unblock();
	};

	$pageNumber = ($currentPage ? $currentPage.pageIndex : 0);

</script>

<PageSection>
	<Form id="landing-page" on:submit={handleSubmit}>
		<div class="row justify-content-md-center">
			<div class="col-md-8 col-sm-12 text-center">
				<h1>Superannuation and Disability Insurance</h1>
				<h2>Online Survey</h2>
			</div>
		</div>
		<div class="row justify-content-md-center">
			<div class="col-md-8 col-sm-12">
				<p>
					Hi, we're here to assist you with your Superannuation and
					Disability Insurance enquiry.
				</p>

				<p>
					Please complete our Online Survey to tell us a bit more
					about yourself as well as your Super Fund(s) or Personal
					Insurance Policy details.
				</p>

				<p>This survey should take you 5-10 minutes to complete.</p>
			</div>
		</div>
		<div class="row justify-content-md-center register-btn form-group">
			<div class="col-md-8 col-sm-12 text-center">
				<NavigationButtons bind:buttons />
			</div>
		</div>
		<div class="row justify-content-md-center">
			<div class="col-md-8 col-sm-12">
				<p>
					If you are in any doubt about whether you need to complete
					this survey, please contact Shine Lawyers on {siteSettings.phoneNumber}
					or via email to
					<a
						href="mailto:{siteSettings.emailAddress}"
						title="Email Super {siteSettings.emailAddress}"
						>{siteSettings.emailAddress}</a
					>.
				</p>
			</div>
		</div>
	</Form>
</PageSection>
